<template>
    <div class="assortment__filter filter-assortment" data-spollers data-one-spoller>
        <div class="filter-assortment__col filter-assortment__col_left">
            <ul class="filter-assortment__list">
            <!-- Filters -->
            <li v-if="categories.length > 0" class="filter-assortment__item">
                <button class="filter-assortment__button filter-assortment__button_name" type="button" data-spoller data-spoller-close>
                {{ title }}
                <svg class="icon">
                    <use xlink:href="/img/front/icons/svgmap.svg#arrow-up"></use>
                </svg>
                </button>
                <ul class="filter-assortment__sub-list" data-spollers data-spollers-speed="0">
                    <div class="row">
                        <div class="col">
                            <li v-for="(item, index) in categories" :key="index" class="filter-assortment__button" :class="isOpen(item.id)" @click="checkAndSub(item)">
                                <button class="filter-assortment__button" type="button"> <!-- data-spoller -->
                                    <svg class="icon top" v-show="isChecked(item.id)">
                                        <use xlink:href="/img/front/icons/svgmap.svg#check"></use>
                                    </svg>
                                    {{ item.meta.title }}
                                    <span class="filters-value" v-if="countCheckedChilds(item) > 0">({{ countCheckedChilds(item) }})</span>
                                    <svg class="icon" v-if="isset(item.childs_categories) && item.childs_categories.length">
                                        <use xlink:href="/img/front/icons/svgmap.svg#arrow-left"></use>
                                    </svg>
                                </button>
                            </li>
                        </div>
                        <div class="col">
                            <!-- <span v-for="(itemInner, indexInner) in item.childs_categories" :key="indexInner">{{ itemInner.meta.title }}</span> -->
                            <ul v-for="item in categories" :key="item.id" v-show="submenu(item.id)" class="filter-assortment__category-list">
                                <li v-for="(itemInner, indexInner) in item.childs_categories" :key="indexInner" @click="checkAndSub(itemInner, true)" class="filter-assortment__category-item">
                                    <svg class="icon top" v-show="isChecked(itemInner.id)">
                                        <use xlink:href="/img/front/icons/svgmap.svg#check"></use>
                                    </svg>
                                    {{ itemInner.meta.title }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </ul>
                
            </li>
            <li class="filter-assortment__item filter-assortment__item_separator"></li>
            <li class="filter-assortment__item">
                <button class="filter-assortment__button filter-assortment__button_price" type="button" data-spoller data-spoller-close>
                {{ trans('filter.price') }}
                <svg class="icon">
                    <use xlink:href="/img/front/icons/svgmap.svg#arrow-up"></use>
                </svg>
                </button>
                <ul class="filter-assortment__sub-list" data-spollers data-spollers-speed="0">
                <div class="filter-assortment__range price-range">
                    <div class="price-range__inputs">
                    <label class="price-range__label">
                        {{ trans('filter.from') }}
                        <input type="number" class="input price-range__input price-range__input_from" id="price-start"/>
                        <span class="price-range__currency">₴</span>
                    </label>
                    <span class="price-range__inputs-separator"></span>
                    <label class="price-range__label">
                        {{ trans('filter.to') }}
                        <input type="number" class="input price-range__input price-range__input_to" id="price-end"/>
                        <span class="price-range__currency">₴</span>
                    </label>
                    </div>
                    <div class="price-range__range" id="range"></div>
                    <button class="price-range__reset" type="button" id="price-reset">{{ trans('filter.reset_filter') }}</button>
                </div>
                </ul>
            </li>
            </ul>
        </div>

        <div class="filter-assortment__col filter-assortment__col_right">
            <ul class="filter-assortment__list">

            <li class="filter-assortment__item">
                <button class="filter-assortment__button filter-assortment__button_name" type="button" data-spoller data-spoller-close>
                {{ trans('filter.sort_by') }}
                <svg class="icon">
                    <use xlink:href="/img/front/icons/svgmap.svg#arrow-up"></use>
                </svg>
                </button>
                <ul class="filter-assortment__sub-list sort-options" data-spollers data-spollers-speed="0">
                <li class="filter-assortment__sub-item sort-options__item">
                    <input hidden id="sort-opt_1" class="sort-options__input" checked type="radio" v-model="data.sort" value="default" name="option">
                    <label for="sort-opt_1" class="sort-options__label">
                    <svg class="icon">
                        <use xlink:href="/img/front/icons/svgmap.svg#check"></use>
                    </svg>
                    <span class="sort-options__text">{{ trans('filter.default') }}</span>
                    </label>
                </li>
                <li class="filter-assortment__sub-item sort-options__item">
                    <input hidden id="sort-opt_3" class="sort-options__input" checked type="radio" v-model="data.sort" value="new" name="option">
                    <label for="sort-opt_1" class="sort-options__label">
                    <svg class="icon">
                        <use xlink:href="/img/front/icons/svgmap.svg#check"></use>
                    </svg>
                    <span class="sort-options__text">{{ trans('filter.latest') }}</span>
                    </label>
                </li>
                <li class="filter-assortment__sub-item sort-options__item">
                    <input hidden id="sort-opt_4" class="sort-options__input" type="radio" v-model="data.sort" value="minToMax" name="option">
                    <label for="sort-opt_2" class="sort-options__label">
                    <svg class="icon">
                        <use xlink:href="/img/front/icons/svgmap.svg#check"></use>
                    </svg>
                    <span class="sort-options__text">{{ trans('filter.from_min_to_max') }}</span>
                    </label>
                </li>
                <li class="filter-assortment__sub-item sort-options__item">
                    <input hidden id="sort-opt_4" class="sort-options__input" type="radio" v-model="data.sort" value="maxToMin" name="option">
                    <label for="sort-opt_3" class="sort-options__label">
                    <svg class="icon">
                        <use xlink:href="/img/front/icons/svgmap.svg#check"></use>
                    </svg>
                    <span class="sort-options__text">{{ trans('filter.from_max_to_min') }}</span>
                    </label>
                </li>
                <li class="filter-assortment__sub-item sort-options__item">
                    <input hidden id="sort-opt_5" class="sort-options__input" type="radio" v-model="data.sort" value="MaxSaleToMinSale" name="option">
                    <label for="sort-opt_4" class="sort-options__label">
                    <svg class="icon">
                        <use xlink:href="/img/front/icons/svgmap.svg#check"></use>
                    </svg>
                    <span class="sort-options__text">{{ trans('filter.from_max_to_min_sale') }}</span>
                    </label>
                </li>
                </ul>
            </li>
            </ul>
        </div>
    </div>
</template>

<script>
import helper from "./../../mixins/helper";
import * as noUiSlider from 'nouislider';

export default {
    mixins: [helper],
    components: {

    },
    props: {
        categories: {
            requeired: false,
            default: null
        },
        title: {
            requeired: false,
            default: null
        },
        max_price: {
            requeired: false,
            default: 0
        },
        min_price: {
            requeired: false,
            default: 0
        },
        get_filter: {
            requeired: false,
            default: 0
        }
    },
    watch: {
        data: {
            handler(val){
                this.$emit("change", val);
            },
            deep: true
        },
    },
    data() {
        return {
            clickedItem: null,
            data: {
                categories: this.get_filter.categories,
                priceMin: this.get_filter.priceMin,
                priceMax: this.get_filter.priceMax,
                sort: this.get_filter.sort
            }
        }
    },
    beforeMount() {
    },
    mounted() {
        this.rangeInit();
    },
    computed: {
       
    },
    methods: {
        setMaxPrice(event) {
            alert();
            this.data.priceMax = value;
        },
        setpriceMin(value) {
            this.data.priceMin = value;
        },
        countCheckedChilds(item) {
            if (this.isset(item.childs_categories)) {
                let i = 0;
                item.childs_categories.forEach(child => {
                    if (this.data.categories.includes(child.id)) {
                        i++;
                    }
                });
                return i;
            }
        },
        isChecked(id) {
            // Logic categories how filter
            // if (this.data.categories.includes(id)) {
            //     return true;
            // } else {
            //     return false;
            // }
        },
        isOpen(id) {
            if (this.clickedItem == id) {
                return 'checked';
            } else if (this.clickedItem) {
                return 'disabled';
            }
        },
        checkAndSub(item, child = false) {
            
            // Logic categories how links
            if (!item.hasOwnProperty('childs_categories') || (item.hasOwnProperty('childs_categories') && item.childs_categories.length == 0)) {
                location.href = item.slug_suffix;
            }
            if (!child && this.isset(item.childs_categories) && item.childs_categories.length > 0) {
                if (this.clickedItem == item.id) {
                    this.clickedItem = null;
                } else {
                    this.clickedItem = item.id;
                }
            }

            // Logic categories how filter

            // if (!child && this.isset(item.childs_categories) && item.childs_categories.length > 0) {
            //     if (this.clickedItem == item.id) {
            //         this.clickedItem = null;
            //     } else {
            //         this.clickedItem = item.id;
            //     }
            // }
            
            // if (!this.isset(item.childs_categories) || item.childs_categories.length == 0) {
            //     if (this.data.categories.includes(item.id)) {
            //         this.data.categories = this.data.categories.filter(catId => {
            //             return catId !== item.id;
            //         });
            //     } else {
            //         this.data.categories.push(item.id);
            //     }
            //     this.$forceUpdate();
            // }
        },
        submenu(id) {
            if (id == this.clickedItem) {
                return true;
            } else {
                return false;
            }
        },
        rangeInit() {
            const priceSlider = document.querySelector("#range");
            const priceReset = document.querySelector("#price-reset");

            const min_price = this.min_price;
            const max_price = this.max_price;
            if (priceSlider) {
                let textFrom = priceSlider.getAttribute("data-from");
                let textTo = priceSlider.getAttribute("data-to");
                let sliderRange = noUiSlider.create(priceSlider, {
                    start: [this.get_filter.priceMin, this.get_filter.priceMax],
                    connect: true,
                    range: {
                        min: [min_price],
                        max: [max_price],
                    },
                });

                const priceStart = document.getElementById("price-start");
                const priceEnd = document.getElementById("price-end");
                priceStart.addEventListener("change", setPriceValues);
                priceEnd.addEventListener("change", setPriceValues);

                priceSlider.noUiSlider.on("update", function(values, handle) {
                    var value = values[handle];

                    if (handle == 0) {
                        priceStart.value = Math.round(value);
                    } else {
                        priceEnd.value = Math.round(value);
                    }
                });

                function setPriceValues() {
                    let priceStartValue;
                    let priceEndValue;
                    if (priceStart.value != "") {
                        priceStartValue = priceStart.value;
                    }
                    if (priceEnd.value != "") {
                        priceEndValue = priceEnd.value;
                    }
                    priceSlider.noUiSlider.set([priceStartValue, priceEndValue]);
                }
                
                sliderRange.on('change.one', () => {
                    this.setPriceMinMax(sliderRange);
                });
                sliderRange.on('set.one', () => {
                    this.setPriceMinMax(sliderRange);
                });
            }

            priceReset.addEventListener("click", function() {
                priceSlider.noUiSlider.set([0, max_price]);
                //priceSlider.noUiSlider.reset();
            });
        },
        setPriceMinMax(sliderRange) {
            this.data.priceMin = Math.ceil(Number(sliderRange.get()[0]));
            this.data.priceMax = Math.ceil(Number(sliderRange.get()[1]));
            this.$forceUpdate();
        }
    }
}
</script>